export enum EapIncomeType {
Item0,
Item1,
Item2,
Item3,
Item4,
item5,
Item6,
}
